import { render, staticRenderFns } from "./ReceiptLogUnitDetailForm.vue?vue&type=template&id=65a680ec"
import script from "./ReceiptLogUnitDetailForm.vue?vue&type=script&lang=js"
export * from "./ReceiptLogUnitDetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports